import React from "react";
import LV_EEX_Locaciones from "../Generales/LV_EEX_Locaciones";

import {
  function_ABM_EEX_PersonasLocaciones_Generar_JSON,
  function_ABM_EEX_PersonasLocaciones_Insertar,
  function_ABM_EEX_PersonasLocaciones_Modificar
} from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_PersonasLocaciones";

const LV_EEX_PersonasLocaciones = (props) => (
  <LV_EEX_Locaciones
    {...props}
    generarJson={function_ABM_EEX_PersonasLocaciones_Generar_JSON}
    insertar={function_ABM_EEX_PersonasLocaciones_Insertar}
    modificar={function_ABM_EEX_PersonasLocaciones_Modificar}
    idCampo="IdPersona"
    campoCodigoLocacion="CodigoLocacionPersona"
  />
);

export default LV_EEX_PersonasLocaciones;